// extracted by mini-css-extract-plugin
export default {"root":"UnderwritingQuestionGroup_root__oLBQi","question":"UnderwritingQuestionGroup_question__0YU1M"};